import { ConferenceType } from '@wui/im'
import { computed } from 'vue'

import { useLocalization } from '@/shared/composables/localization'
import { Room } from '@/shared/types/store'
import { getTextForDifferentCount } from '@/shared/utils/get-text-for-different-count'

export const useRoomMembersLabel = (room: Room, needToCountModerators = true) => {
  const { tc } = useLocalization()

  const label = computed(() => {
    let probablyModeratorsCountText = ''
    if (room.mode === ConferenceType.MODERATED && needToCountModerators) {
      const count = room.contacts?.filter(c => c.role === 'Owner' || c.role === 'Moderator').length
      if (count) {
        probablyModeratorsCountText = `${getTextForDifferentCount(count, {
          forOne: tc('common.moderator', 0),
          forTwo: tc('common.moderator', 1),
          forFive: tc('common.moderator', 2),
        })}, `
      }
    }

    return `${probablyModeratorsCountText}${getTextForDifferentCount(room.subscribers.size + (room.guests?.size ?? 0), {
      forOne: tc('common.participant', 0),
      forTwo: tc('common.participant', 1),
      forFive: tc('common.participant', 2),
    })}`
  })

  return {
    label,
  }
}
